$(document).ready(function(){
    if(window.location.hash.indexOf('#opencartdrawer') > -1) {
        document.querySelector('[aria-controls="cart-drawer"]')?.click();
        const url = window.location.href.replace("#opencartdrawer", "");
        history.replaceState(null, null, url);
    } 
    function formatMoney(cents, format = "") {
        if (typeof cents === "string") {
            cents = cents.replace(".", "");
        }
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || window.themeVariables.settings.moneyFormat;
        function defaultTo(value2, defaultValue) {
            return value2 == null || value2 !== value2 ? defaultValue : value2;
        }
        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultTo(precision, 2);
            thousands = defaultTo(thousands, ",");
            decimal = defaultTo(decimal, ".");
            if (isNaN(number) || number == null) {
            return 0;
            }
            number = (number / 100).toFixed(precision);
            let parts = number.split("."),
            dollarsAmount = parts[0].replace(
                /(\d)(?=(\d\d\d)+(?!\d))/g,
                "$1" + thousands
            ),
            centsAmount = parts[1] ? decimal + parts[1] : "";
            return dollarsAmount + centsAmount;
        }
        let value = "";
        switch (formatString.match(placeholderRegex)[1]) {
            case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
            case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
            case "amount_with_space_separator":
            value = formatWithDelimiters(cents, 2, " ", ".");
            break;
            case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
            case "amount_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 2, "'", ".");
            break;
            case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
            case "amount_no_decimals_with_space_separator":
            value = formatWithDelimiters(cents, 0, " ");
            break;
            case "amount_no_decimals_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 0, "'");
            break;
        }
        if (formatString.indexOf("with_comma_separator") !== -1) {
            return formatString.replace(placeholderRegex, value);
        } else {
            return formatString.replace(placeholderRegex, value);
        }
    }
    var currencyFormat = window.themeVariables.settings.currencyCodeEnabled
    ? window.themeVariables.settings.moneyWithCurrencyFormat
    : window.themeVariables.settings.moneyFormat;

    var IMAGE_SRC = 'https://cdn.shopify.com/s/files/1/0089/6807/7397/files/Plush_-_Birthday_Sale_-_100x100-_1.png?v=1785761603'; // <-- change me
 
    function runImageConfetti(canvasEl, imageSrc, options) {
        options = options || {};
        
        var spawnDuration     = options.spawnDuration     || 1800; // ms, how long new pieces keep spawning
        var fallToHeightPct   = options.fallToHeightPct   || 0.8;  // fraction of canvas height to fall to
        var fadeDuration      = options.fadeDuration      || 800;  // ms, fade-out length once target reached
        var imageWidth         = options.imageWidth        || 56;   // px, target width (height auto from aspect ratio)
        var gravity            = options.gravity           || 0.04; // px/frame^2 acceleration (gentle)
        var terminalVelocity   = options.terminalVelocity  || 4.5;  // px/frame cap, keeps fall steady instead of speeding up forever
        var minStartSpeed      = options.minStartSpeed     || 0.5;
        var maxStartSpeed      = options.maxStartSpeed     || 1.5;
        var swayAmplitude       = options.swayAmplitude    || 25;   // px, side-to-side flutter
        var swayFrequency       = options.swayFrequency    || 0.02; // how fast it sways
        var maxRotationSpeed    = options.maxRotationSpeed || 0.015; // radians/frame, gentle tumble
        var particleCount       = options.particleCount    || 40;   // TOTAL number of images spawned per burst
        
        var ctx = canvasEl.getContext('2d');
        var img = new Image();
        img.crossOrigin = 'anonymous';
        
        img.onload = function () {
            var aspect = img.naturalHeight / img.naturalWidth || 1;
            start(canvasEl, ctx, img, {
            spawnDuration: spawnDuration,
            fallToHeightPct: fallToHeightPct,
            fadeDuration: fadeDuration,
            imageWidth: imageWidth,
            imageHeight: imageWidth * aspect,
            gravity: gravity,
            terminalVelocity: terminalVelocity,
            minStartSpeed: minStartSpeed,
            maxStartSpeed: maxStartSpeed,
            swayAmplitude: swayAmplitude,
            swayFrequency: swayFrequency,
            maxRotationSpeed: maxRotationSpeed,
            particleCount: particleCount
            });
        };
        img.onerror = function () {
            console.error('image-confetti: failed to load image', imageSrc);
        };
        img.src = imageSrc;
    }
    
    function start(canvas, ctx, img, opts) {
    var dpr = window.devicePixelRatio || 1;
    
    function resize() {
        canvas.width = window.innerWidth * dpr;
        canvas.height = window.innerHeight * dpr;
        canvas.style.width = window.innerWidth + 'px';
        canvas.style.height = window.innerHeight + 'px';
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    resize();
    window.addEventListener('resize', resize);
    
    var cssWidth = function () { return canvas.width / dpr; };
    var cssHeight = function () { return canvas.height / dpr; };
    
    var particles = [];
    var spawnStart = Date.now();
    var spawnEnd = spawnStart + opts.spawnDuration;
    var spawnInterval = opts.spawnDuration / opts.particleCount;
    var spawnedCount = 0;
    var targetY = cssHeight() * opts.fallToHeightPct;
    
    function spawnParticle() {
        var speed = opts.minStartSpeed + Math.random() * (opts.maxStartSpeed - opts.minStartSpeed);
        particles.push({
        baseX: Math.random() * cssWidth(),
        x: 0,
        y: -opts.imageHeight,
        vy: speed,
        rotation: Math.random() * Math.PI * 2,
        rotationSpeed: (Math.random() - 0.5) * 2 * opts.maxRotationSpeed,
        scale: 0.85 + Math.random() * 0.3,
        swayPhase: Math.random() * Math.PI * 2,
        swaySpeed: opts.swayFrequency * (0.7 + Math.random() * 0.6),
        swayAmp: opts.swayAmplitude * (0.6 + Math.random() * 0.8),
        age: 0,
        opacity: 1,
        fading: false,
        fadeStart: 0
        });
    }
    
    function frame() {
        ctx.clearRect(0, 0, cssWidth(), cssHeight());
    
        var now = Date.now();
        var shouldHaveSpawned = Math.min(opts.particleCount, Math.floor((now - spawnStart) / spawnInterval) + 1);
        while (spawnedCount < shouldHaveSpawned) {
        spawnParticle();
        spawnedCount++;
        }
    
        for (var i = particles.length - 1; i >= 0; i--) {
        var p = particles[i];
        p.age++;
    
        if (!p.fading) {
            p.vy = Math.min(opts.terminalVelocity, p.vy + opts.gravity);
            p.y += p.vy;
            p.rotation += p.rotationSpeed;
    
            if (p.y >= targetY) {
            p.fading = true;
            p.fadeStart = now;
            }
        } else {
            var elapsed = now - p.fadeStart;
            p.opacity = Math.max(0, 1 - elapsed / opts.fadeDuration);
            p.y += p.vy * 0.5;
            p.rotation += p.rotationSpeed * 0.5;
        }
    
        // gentle side-to-side flutter layered on top of the vertical fall
        p.x = p.baseX + Math.sin(p.age * p.swaySpeed + p.swayPhase) * p.swayAmp;
    
        var w = opts.imageWidth * p.scale;
        var h = opts.imageHeight * p.scale;
    
        ctx.save();
        ctx.globalAlpha = p.opacity;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.drawImage(img, -w / 2, -h / 2, w, h);
        ctx.restore();
    
        if (p.opacity <= 0 || p.y - h / 2 > cssHeight()) {
            particles.splice(i, 1);
        }
        }
    
        if (particles.length > 0 || spawnedCount < opts.particleCount) {
        requestAnimationFrame(frame);
        } else {
        ctx.clearRect(0, 0, cssWidth(), cssHeight());
        }
    }
    
    requestAnimationFrame(frame);
    }
    
    if(document.getElementById('cart-confetti')){
        var canvas = document.getElementById('cart-confetti');
        runImageConfetti(canvas, IMAGE_SRC, {
            spawnDuration: 2500,
            fallToHeightPct: 0.5,
            fadeDuration: 1500,
            imageWidth: 150,
            particleCount: 15   // <-- total images per burst, lower = fewer
        });
    }

    $('body').on('keyup','#coupon_code_input', function(){
        if($(this).val().length > 0){
        $(this).closest('.cart-coupon_offer-input').find('.offer_button').addClass('active');
        }else{
        $(this).closest('.cart-coupon_offer-input').find('.offer_button').removeClass('active');
        }
    });

    function existingDiscounts(){
        const discountCodes = [];
        const discountPills = $('.applied_codes').find('.code_block');
        for (const pill of discountPills) {
        if (typeof $(pill).attr('data-discount-code') === 'string') {
            discountCodes.push($(pill).attr('data-discount-code'));
        }
        }
        
        return discountCodes;
    }

    $('body').on('click','[data-inputapply]', function(){
        $('.offer_input_err').remove();
        $(this).closest('[is="loader-button"]').addClass('loading');
        document.documentElement.dispatchEvent(
            new CustomEvent("theme:loading:start", { bubbles: true })
        );
        var _this = $(this);
        var sectionId = _this.closest('cart-drawer').attr('section');
        var discountCodeValue = _this.closest('.cart-coupon_offer-input').find('#coupon_code_input').val();
        if(discountCodeValue == ''){
            _this.closest('.cart-coupon_offer-input').after('<p class="offer_input_err">Please enter any code above.</p>');
            $(this).closest('[is="loader-button"]').removeClass('loading');
            document.documentElement.dispatchEvent(
            new CustomEvent("theme:loading:end", { bubbles: true })
            );
            return;
        }
        var existingDiscountsValue = existingDiscounts();
        
        if (existingDiscountsValue.includes(discountCodeValue)) return;
        
        async function getupdatedata(){     
            let response = await fetch(`${window.themeVariables.settings.cart_update_url}.js`, {
                method: "POST", // HTTP method (GET, POST, PUT, DELETE, etc.)
                headers : {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    discount: [...existingDiscountsValue, discountCodeValue].join(','),
                    sections: [sectionId]
                })
            });
            const data = await response.json();
            return data;
        }
        getupdatedata().then(data => {
            console.log(data);
            if (data.discount_codes.find((/** @type {{ code: string; applicable: boolean; }} */ discount) => {
                return discount.code === discountCodeValue && discount.applicable === false;
            })
        ) {
            _this.closest('.cart-coupon_offer-input').after('<p class="offer_input_err">Invalid coupon code. Try again.</p>');
            _this.closest('[is="loader-button"]').removeClass('loading');
            document.documentElement.dispatchEvent(
            new CustomEvent("theme:loading:end", { bubbles: true })
            );
            return;
        }

        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
            cart: data
            }
        }));
        
        _this.closest('[is="loader-button"]').removeClass('loading');
        document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:end", { bubbles: true })
        );
        });
    });

    $('body').on('click','[data-removecode]', function(){
        $(this).closest('.code_block').addClass('loading');
        document.documentElement.dispatchEvent(
            new CustomEvent("theme:loading:start", { bubbles: true })
        );
        var sectionId = $(this).closest('cart-drawer').attr('section');
        var discountCodeValue = $(this).closest('.code_block').attr('data-discount-code');
        var existingDiscountsValue = existingDiscounts();
        
        const index = existingDiscountsValue.indexOf(discountCodeValue);
        if (index === -1){
            $(this).closest('.code_block').removeClass('loading');
            return;
        } 

        existingDiscountsValue.splice(index, 1);
        
        async function getupdatedata(){     
            let response = await fetch(`${window.themeVariables.settings.cart_update_url}.js`, {
                method: "POST", // HTTP method (GET, POST, PUT, DELETE, etc.)
                headers : {
                "Content-Type": "application/json"
                },
                body: JSON.stringify({ 
                discount: existingDiscountsValue.join(','),
                sections: [sectionId]
                })
            });
            const data = await response.json();
            return data;
        }
        getupdatedata().then(data => {
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                bubbles: true,
                detail: {
                cart: data
                }
            }));
            $(this).closest('.code_block').removeClass('loading');
            document.documentElement.dispatchEvent(
                new CustomEvent("theme:loading:end", { bubbles: true })
            );
        });
    });

    $('body').on('click','.discount-price-wrapper .total_price_main', function(){
        if($(this).hasClass('active')){
        $(this).removeClass('active');
        $(this).closest('.discount-price-wrapper').find('.payment-summary-list').slideUp();
        }else{
        $(this).addClass('active');
        $(this).closest('.discount-price-wrapper').find('.payment-summary-list').slideDown();
        }
    });

    $('body').on('click','[data-cart-atc]', function(e){
        e.preventDefault();
        var _this = $(this);
        $(this).addClass('loading');
        console.log('innnn')
        var items = [];
        items.push({
            quantity: 1,
            id: $(this).attr('data-vid')
        });
        
        var data = {items};
        console.log(data);
        fetch(`${Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => response.json())
        .then(function(data) {
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                bubbles: true,
                detail: {
                cart: data
                }
            }));
            _this.removeClass('loading');
        }.bind(this));  
    });

    $('body').on('click','.bundle_variants_list .quantity-selector__button', function(e){
        var _this = this;
        var qtylimit = parseInt($(_this).closest('.bundle_variants_list').attr('data-qtylimit'));
        
        var input = $(this).closest('.quantity-selector').find('[name="quantity"]');
        if($(this).hasClass('plus_icon')){
            if($(_this).hasClass('limitcrossed')){
                alert('You’ve hit the '+qtylimit+' pad quantity limit! Try removing one to add another. ✨');
                return;
            }
            input.val(parseInt(input.val()) + 1);    
        }else{
            input.val(parseInt(input.val()) - 1);
        }
        if(input.val() == 0){
            $(this).closest('.quantity-selector').find('.minus_icon').attr('disabled','disabled');
        }else{
            $(this).closest('.quantity-selector').find('.minus_icon').removeAttr('disabled');
        }
        
        var totalqty = 0;
        var totalprice = 0;
        var totalcompprice = 0;
        $(_this).closest('.variant_list_flex').find('.bundle_variant_item').each(function(i,e){
            if(parseInt($(this).find('[name="quantity"]').val()) > 0){
                totalqty += parseInt($(this).find('[name="quantity"]').val());
                totalprice += parseInt($(this).attr('data-varprice')) * parseInt($(this).find('[name="quantity"]').val());
                totalcompprice += parseInt($(this).attr('data-varcompprice')) * parseInt($(this).find('[name="quantity"]').val());
            }else{
                totalprice += 0;
                totalcompprice += 0;
            }
        });
        var stickypricehtml = '<sale-price class="h4 text-on-sale">'+ formatMoney(totalprice, currencyFormat) +'</sale-price>';
        var pricehtml = '<sale-price class="h4 text-on-sale">'+ formatMoney(totalprice, currencyFormat) +'</sale-price>';

        if(totalprice < totalcompprice){
            stickypricehtml += '<compare-at-price class="h5 text-subdued line-through">'+formatMoney(totalcompprice, currencyFormat) +'</compare-at-price>'
            pricehtml += '<compare-at-price class="h5 text-subdued line-through">'+formatMoney(totalcompprice, currencyFormat) +'</compare-at-price>';

            const saving = ((totalcompprice - totalprice) * 100) / totalcompprice;
            const roundedNumber = Math.round(saving) + '% OFF';
            pricehtml += '<div class="percent-off text-product-fs">'+roundedNumber+'</div>';
            stickypricehtml += '<div class="percent-off text-product-fs">'+roundedNumber+'</div>';
        }

        $(_this).closest('.product-info').find('.product-info__block-item:is([data-block-type=price]) .price-list').html(pricehtml);
        $('product-sticky-bar').find('.price-list').html(stickypricehtml);
        if(totalprice > 0){
            $(_this).closest('.product-info').find('.product-info__block-item:is([data-block-type=price])').show();
            $('product-sticky-bar').find('.price-list').show();
        }else{
            $(_this).closest('.product-info').find('.product-info__block-item:is([data-block-type=price])').hide();
            $('product-sticky-bar').find('.price-list').hide();
        }
        var formid = $(_this).closest('.quantity-selector').attr('data-form');
        if(totalqty == qtylimit){
            $(_this).closest('.variant_list_flex').find('.quantity-selector .plus_icon').addClass('limitcrossed');
            $('.buy-buttons[form="'+formid+'"] button').removeClass('disabled').removeAttr('disabled').attr('type','submit').find('.btn_text').text($('.buy-buttons[form="'+formid+'"] button').attr('data-buttontext'));
        }else{
            console.log('elsss')
            $(_this).closest('.variant_list_flex').find('.quantity-selector .plus_icon').removeClass('limitcrossed');
            $('.buy-buttons[form="'+formid+'"] button').addClass('disabled').attr('disabled','disabled').attr('type','button').find('.btn_text').text($('.buy-buttons[form="'+formid+'"] button').attr('data-defaulttext'));
            $(_this).closest('.variant_list_flex').find('.bundle_variant_item .quantity-selector .quantity-selector__button:last-child').removeAttr('disabled');
        }
    });

    $('body').on('click','[data-bundleatc]', async function(e){
        e.preventDefault();
        var _this = $(this);
        $(this).addClass('loading');
        document.documentElement.dispatchEvent(
            new CustomEvent("theme:loading:start", { bubbles: true })
        );

        var uid = Date.now().toString(36) + Math.random().toString(36).substr(2);
        var cnnt = 0;
        let items = [];

        $('.bundle_variants_list .bundle_variant_item').each(function(){
            cnnt += 1;
            let qty = parseInt($(this).find('[name="quantity"]').val());

            if(qty > 0){
                if(cnnt == 1){
                    var _itemtype = 'mainitem';
                }else{
                    var _itemtype = 'subitem';
                }                
                items.push({
                    quantity: qty,
                    id: $(this).attr('data-vid'),
                    properties: {
                      '_bundleid': uid,
                      '_itemtype': _itemtype,
                      '_baseqty': parseInt(qty)
                    }
                });
            }
        });

        if(items.length === 0) return;

        let sectionsToRender = [];

        // ✅ collect sections (VERY IMPORTANT)
        document.documentElement.dispatchEvent(
            new CustomEvent("cart:prepare-bundled-sections", {
            bubbles: true,
            detail: { sections: sectionsToRender },
            })
        );

        try {
            let response = await fetch(`${Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            body: JSON.stringify({
                items: items,
                sections: sectionsToRender.join(',')
            }),
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
            });

            let data = await response.json();
            console.log('Response:', data);

            if (response.ok) {
                document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                    bubbles: true,
                    detail: {
                        baseEvent: "variant:add",
                        cart: data
                    }
                }));
            }else{
                console.log('ininininnii')
                var errorbannerhtml = `<div class="banner banner--error" role="alert" aria-live="polite">
                    ${data["description"]}
                </div>`;
                _this.before(errorbannerhtml);
                setTimeout(function(){
                    $('.banner.banner--error').remove();
                },2000);
            }
            document.dispatchEvent(new CustomEvent("cart:refresh"));

            
            document.documentElement.dispatchEvent(
                new CustomEvent("theme:loading:end", { bubbles: true })
            );
            $(this).removeClass('loading');

        } catch (error) {
            console.error('Error:', error);
        }
    });

    function initAnnouncement(){

        var wrapper = $('.announcement-bar .bar_content_wrapper');
        var messages = wrapper.find('.bar_message');
        var count = messages.length;
        var width = $(window).width();

        wrapper.removeClass('marquee center');

        if(width <= 768){

        wrapper.addClass('marquee');

        if(wrapper.find('.duplicate').length == 0){
            wrapper.append(messages.clone().addClass('duplicate'));
        }

        }else{

        if(count > 1){

            wrapper.addClass('marquee');

            if(wrapper.find('.duplicate').length == 0){
            wrapper.append(messages.clone().addClass('duplicate'));
            }

        }else{

            wrapper.addClass('center');

        }

        }

    }

    initAnnouncement();

    $(window).on('resize', function(){
        initAnnouncement();
    });

    $('body').on('click','.bundle_lineitem_aside .bundle_remove_link', function(){
        document.documentElement.dispatchEvent(
            new CustomEvent("theme:loading:start", { bubbles: true })
        );
        var __this = this;
        $(__this).addClass('loading');
        var listupdateData = {};
        $(this).closest('.linebundle_wrapper').find('.line-item').each(function(i,e){
            listupdateData[$(e).attr('data-lineid')] = 0;
        });
        if (Object.keys(listupdateData).length != 0) {
            $.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: {
                    updates: listupdateData
                },
                dataType: 'json',
                success: function(data) {                
                    console.log(data);
                    document.dispatchEvent(new CustomEvent("cart:refresh"));
                    document.documentElement.dispatchEvent(
                        new CustomEvent("theme:loading:end", { bubbles: true })
                    );
                    $(__this).removeClass('loading');
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    console.log(jqXHR);
                }
            });
        }
    });

    // Bind once globally; works for any number of blocks on the page.
    function setup($) {
        function moveIndicator($section) {
        if (!$section || !$section.length) { return; }
        var $tabs = $section.find('[role="tab"]');
        var $indicator = $section.find('.product-tabs__indicator');
        if (!$tabs.length || !$indicator.length) {
            if ($indicator.length) { $indicator.hide(); }
            return;
        }
        var $active = $tabs.filter('[aria-selected="true"]').first();
        if (!$active.length) { $active = $tabs.first(); }
        $indicator.css({
            left: $active[0].offsetLeft + 'px',
            width: $active[0].offsetWidth + 'px'
        });
        }

        function selectTab($section, $tab) {
        if (!$section.length || !$tab || !$tab.length) { return; }
        var $tabs = $section.find('[role="tab"]');
        $tabs.each(function () {
            var $t = $(this);
            var selected = $t.is($tab);
            $t.attr('aria-selected', selected);
            $t.attr('tabindex', selected ? 0 : -1);
            var panelId = $t.attr('aria-controls');
            if (panelId) {
            var $panel = $section.find('#' + window.CSS.escape(panelId));
            if ($panel.length) { $panel.prop('hidden', !selected); }
            }
        });
        moveIndicator($section);
        }

        function positionAll() {
        $('.product-tabs').each(function () { moveIndicator($(this)); });
        }

        if (!window.__productTabsBound) {
        window.__productTabsBound = true;

        $(document).on('click', '.product-tabs__btn', function () {
            selectTab($(this).closest('.product-tabs'), $(this));
        });

        $(document).on('keydown', '.product-tabs__nav', function (e) {
            var $section = $(this).closest('.product-tabs');
            var $tabs = $section.find('[role="tab"]');
            var idx = $tabs.index(document.activeElement);
            if (idx < 0 || !$tabs.length) { return; }
            var n = $tabs.length, $next;
            if (e.key === 'ArrowRight') { $next = $tabs.eq((idx + 1) % n); }
            else if (e.key === 'ArrowLeft') { $next = $tabs.eq((idx - 1 + n) % n); }
            else if (e.key === 'Home') { $next = $tabs.eq(0); }
            else if (e.key === 'End') { $next = $tabs.eq(n - 1); }
            if ($next && $next.length) {
            e.preventDefault();
            $next.focus();
            selectTab($section, $next);
            }
        });

        $(window).on('load resize', positionAll);

        // Shopify / Prestige theme editor events
        if (window.Shopify && Shopify.designMode) {
            $(document).on('shopify:section:load shopify:block:select shopify:block:deselect', positionAll);
        }
        }

        positionAll();
    }

    // Wait for jQuery (it may still be loading from the CDN above).
    var tries = 0;
    var timer = setInterval(function () {
        if (window.jQuery) {
            clearInterval(timer);
            window.jQuery(function ($) { setup($); });
        } else if (++tries > 100) {
            clearInterval(timer);
        }
    }, 100);

    if($('.announcement-bar__item-timer').length){
        const demo = document.getElementById('ann-demo');
        if (demo) {  
        // Only end date
        const endDate = new Date(demo.getAttribute('data-end')).getTime();
        const wrapper = demo.closest('.announcement-bar__item-timer');
        const x = setInterval(function () {
            const now = new Date().getTime();
            // Timer End
            if (now >= endDate) {
            clearInterval(x);
            if (wrapper) {
                wrapper.classList.add('removed');
            }
            return;
            }
            // Show timer
            if (wrapper) {
            wrapper.classList.remove('removed');
            }
            // Remaining time
            const distance = endDate - now;
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            const minutes = Math.floor(
            (distance % (1000 * 60 * 60)) / (1000 * 60)
            );
            const seconds = Math.floor(
            (distance % (1000 * 60)) / 1000
            );
            let timerHTML = '';
            // Show days only if greater than 0
            if (days > 0) {
            const daytext = days === 1 ? 'Day' : 'Days';
            timerHTML += `${days}${daytext} : `;
            }
            timerHTML += `${hours}Hrs : ${minutes}Min : ${seconds}Sec`;
            demo.innerHTML = timerHTML;
        }, 1000);
        }
    }

    if($('.timer-section').length){
        const demo = document.getElementById('timer-section-demo');
        // console.log('wwwwwwwwwwwww')
        if (demo) {  
        // console.log('dddddddddddd')
            // Only end date
            const endDate = new Date(demo.getAttribute('data-end')).getTime();
            const wrapper = demo.closest('.timer-section');
            const x = setInterval(function () {
            const now = new Date().getTime();
            // Timer End
            if (now >= endDate) {
                clearInterval(x);
                if (wrapper) {
                wrapper.classList.add('removed');
                }
                return;
            }
            // Show timer
            if (wrapper) {
                wrapper.classList.remove('removed');
            }
            // Remaining time
            const distance = endDate - now;
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor(
                (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            const minutes = Math.floor(
                (distance % (1000 * 60 * 60)) / (1000 * 60)
            );
            const seconds = Math.floor(
                (distance % (1000 * 60)) / 1000
            );
            let timerHTML = '';
            // Show days only if greater than 0
            if (days > 0) {
                const daytext = days === 1 ? 'Day' : 'Days';
                timerHTML += `${days}${daytext} : `;
            }
            timerHTML += `${hours}Hrs : ${minutes}Min : ${seconds}Sec`;
            demo.innerHTML = timerHTML;
            }, 1000);
        }
    }

    if ($('.pdp-timer-block').length) {
        const $timer = $('#pdp-timer-block-demo');
        const hoursSetting = parseFloat($timer.data('hours')) || 1;
        const duration = hoursSetting * 60 * 60 * 1000;
        let endTime = Date.now() + duration;

        function updateTimer() {
            let totalSeconds = Math.ceil((endTime - Date.now()) / 1000) - 1;

            if (totalSeconds < 0) {
            endTime = Date.now() + duration;
            totalSeconds = Math.ceil(duration / 1000) - 1;
            }

            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;

            let timerHTML = '';
            if (hours > 0) {
            timerHTML += `${hours}hrs : `;
            }
            timerHTML += `${minutes}min : ${seconds}sec`;

            $timer.html(timerHTML);
        }

        updateTimer();
        setInterval(updateTimer, 1000);
    }

    if($('.product-info-top-banner-wrap').length > 0){
          console.log($('.product-info-top-banner-list').length)
          const swiper = new Swiper('.product-info-top-banner-list', {
              slidesPerView: 1,      // ✅ 1 slide at a time
              spaceBetween: 10,
              loop: true,            // ✅ infinite scroll
              speed: 500,
              autoplay: {
                delay: 2000,
                disableOnInteraction: false,
                },
            navigation: {
                  nextEl: '.swiper-btn-next',
                  prevEl: '.swiper-btn-prev',
              }
          });
      }

});

if(document.querySelector('.product-info')){
    document.querySelector('.product-info').addEventListener('toggle', function(e) {
      if (e.target.tagName !== 'DETAILS' || !e.target.open) return;
      document.querySelectorAll('.product-info accordion-disclosure details[open]').forEach(function(el) {
        if (el !== e.target) {
          el.removeAttribute('open');
          el.setAttribute('aria-expanded', 'false');
        }
      });
    }, true); // capture phase needed since 'toggle' doesn't bubble
}

document.querySelectorAll('.read-more-wrapper').forEach(wrapper => {
  const text = wrapper.querySelector('.read-more-text');
  const btn = wrapper.querySelector('.read-more-btn');

  btn.addEventListener('click', () => {
    text.classList.toggle('expanded');

    btn.textContent = text.classList.contains('expanded')
      ? 'Read Less'
      : 'Read More';
  });
});

if (!window.customElements.get('offer-countdown')) {
  class OfferCountdown extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-unit]')).reduce((map, item) => {
        map[item.dataset.unit] = {
          item,
          value: item.querySelector('[data-value]'),
          arc: item.querySelector('.offer-countdown__arc'),
          progress: 0
        };
        return map;
      }, {});

      this.wrapper = this.closest('[data-offer-countdown-wrapper]');
      this.tick = this.tick.bind(this);
      this.tick();
      this.interval = setInterval(this.tick, 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    get endDate() {
      if (this.getAttribute('mode') === 'daily') {
        const end = new Date();
        end.setHours(parseInt(this.getAttribute('daily-end-hour') || '0', 10), 0, 0, 0);

        if (end <= new Date()) {
          end.setDate(end.getDate() + 1);
        }

        return end;
      }

      const expiresAt = this.getAttribute('expires-at');
      return expiresAt ? new Date(expiresAt) : null;
    }

    tick() {
      const endDate = this.endDate;

      // No valid end date: nothing to count down to (only reachable inside the theme editor)
      if (!endDate || isNaN(endDate)) {
        clearInterval(this.interval);
        this.render(0, 0, 0, 0);
        return this.setVisible(!!window.Shopify?.designMode);
      }

      let delta = Math.max(0, Math.floor((endDate - new Date()) / 1000));

      if (delta === 0 && this.getAttribute('mode') !== 'daily') {
        clearInterval(this.interval);

        // Expired: keep the section hidden, unless "leave" is chosen or we are inside the theme editor
        if (this.getAttribute('expiration-behavior') === 'hide' && !window.Shopify?.designMode) {
          return this.setVisible(false);
        }
      }

      // Without a days ring, the hours keep counting past 24
      const days = this.items.days ? Math.floor(delta / 86400) : 0;
      delta -= days * 86400;
      const hours = Math.floor(delta / 3600);
      delta -= hours * 3600;
      const minutes = Math.floor(delta / 60);
      const seconds = delta - minutes * 60;

      this.render(days, hours, minutes, seconds);
      this.setVisible(true);
    }

    setVisible(visible) {
      if (this.wrapper) {
        this.wrapper.hidden = !visible;
      }
    }

    render(days, hours, minutes, seconds) {
      const daysMax = Math.max(1, parseInt(this.getAttribute('days-max') || '7', 10));

      // Hide leading units that are 0: days when there are no days left, hours when there are no days or hours left
      this.toggleUnit('days', days > 0);
      this.toggleUnit('hours', days > 0 || hours > 0);

      this.update('days', days, Math.min(days / daysMax, 1));
      this.update('hours', hours, (hours % 24) / 24);
      this.update('minutes', minutes, minutes / 60);
      this.update('seconds', seconds, seconds / 60);
    }

    toggleUnit(unit, visible) {
      if (this.items[unit]) {
        this.items[unit].item.hidden = !visible;
      }
    }

    update(unit, value, progress) {
      const entry = this.items[unit];

      if (!entry) {
        return;
      }

      // Rings shrink as time runs down. When one refills (e.g. seconds 00 -> 59) skip the transition so it jumps
      // straight to full instead of sweeping around. Also true on the first render, so the rings don't animate in.
      entry.item.classList.toggle('is-wrapping', progress > entry.progress);
      entry.progress = progress;

      entry.value.textContent = Math.min(value, 99).toString().padStart(2, '0');
      entry.arc.style.strokeDasharray = `${(progress * 100).toFixed(2)} 100`;
      entry.item.style.setProperty('--progress', progress.toFixed(4));
    }
  }

  window.customElements.define('offer-countdown', OfferCountdown);
}

if (!window.customElements.get('available-offers')) {
  class AvailableOffers extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.addEventListener('click', this.onClick.bind(this), { signal: this.abortController.signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    async onClick(event) {
      const button = event.target.closest('.available-offers__copy');

      if (!button) {
        return;
      }

      const copied = await this.copy(button.dataset.code);

      if (!copied) {
        return;
      }

      button.dataset.originalText ??= button.textContent;
      button.textContent = button.dataset.copiedText || button.dataset.originalText;
      button.classList.add('is-copied');

      clearTimeout(button.copyTimeout);
      button.copyTimeout = setTimeout(() => {
        button.textContent = button.dataset.originalText;
        button.classList.remove('is-copied');
      }, 2000);
    }

    async copy(text) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (error) {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();

        const copied = document.execCommand('copy');
        textarea.remove();
        return copied;
      }
    }
  }

  window.customElements.define('available-offers', AvailableOffers);
}
